module.exports = __webpack_public_path__ + "img/Dash_route.4fa5bef4.svg";